<template>
  <table v-if="loading" class="table table-borderless table-border table-align col-md-12">
    <thead>
      <tr>
        <th>Placa</th>
        <th>Renavam</th>
        <th>CNPJ</th>
        <th>Vencimento</th>
        <th></th>
      </tr>
      </thead>
    <tbody>
      <tr v-for="item in 5" :key="item.index">
        <td class="pt-2"><Skeleton animation-duration="1.8s" /></td>
        <td class="pt-2"><Skeleton animation-duration="1.9s"/></td>
        <td class="pt-2"><Skeleton animation-duration="2s"/></td>
        <td class="pt-2"><Skeleton animation-duration="1.5s"/></td>
        <td class="pt-2"><Skeleton col="10" /></td>
      </tr>
    </tbody>
  </table>

  <table v-else class="table table-borderless table-border table-align col-md-12">
    <thead>
      <tr>
        <th>Placa</th>
        <th>Renavam</th>
        <th>CNPJ</th>
        <th>Vencimento</th>
        <th>Atualizado em</th>
        <th></th>
      </tr>
    </thead>
    <tbody v-if="vehicles.length">
      <tr v-for="vehicle in vehicles" :key="vehicle.id">
        <td>{{ vehicle.plate }}</td>
        <td>{{ vehicle.renavam }}</td>
        <td v-if="vehicle.cnpj">{{ vehicle.cnpj | cnpj }}</td>
        <td v-else> - </td>
        <td
            :style="{ color: expiredColor(diffDays(vehicle.validAt))}"
            :title="dateFormatted(vehicle.validAt)"
        >
          {{ expiredMessage(diffDays(vehicle.validAt)) }}
        </td>
        <td> {{ vehicle.updatedAt | datetime }} </td>
        <td>
          <router-link :to="link(vehicle.renavam)">
            <button  class="btn btn-sm btn-primary mr-2">Detalhes</button>
          </router-link>
        </td>
      </tr>
    </tbody>

    <div v-else class="mt-4">
        Não foi encontrado nenhum veículo
    </div>
  </table>
</template>

<script>
import GetAccount from '@/mixins/GetAccount'
import Skeleton from '@/components/utils/Skeleton'

const memoization = {}

export default {
  components: {Skeleton},
  methods: {
    link(renavam) {
      const params = [
        '/cm-crono?',
        'o[]=updated_at',
        'o[]=desc',
        `q[generic]=${renavam}`,
        `q[period_type]=${this.periodType || 'occurred_at'}`,
        `q[start_date]=${this.startDate}`,
        `q[end_date]=${this.endDate}`
      ]

      if (this.entityStatusId)
        params.push(`q[entity_status_id]=${this.entityStatusId}`)

      return params.join('&')
    },
    diffDays(string) {
      if (memoization[string])
        return memoization[string]

      const currentDate = new Date()
      const utcDate = `${string} ${currentDate.getUTCHours()}:${currentDate.getUTCMinutes()}:00`
      const diff = new Date(utcDate) - currentDate
      const days = Math.floor(diff / (1000 * 60 * 60 * 24))

      memoization[string] = days
      return days
    },
    expiredMessage(days) {
      if (days === 0)
        return 'Expira hoje'
      else if (days === 1)
        return 'Expira amanhã'
      else if (days === -1)
        return 'Expirou ontem'
      else if (days > 1)
        return `Expira em ${days} dias`
      else
        return `Expirado há ${Math.abs(days)} dias`
    },
    expiredColor(days) {
      if (days === 0)
        return 'red'
      else if (days > 0)
        return ''
      else
        return 'red'
    },
    dateFormatted(string) {
      return string.split('-').reverse().join('/')
    }
  },
  name: 'Vehicles',
  mixins: [GetAccount],
  props: {
    vehicles: { required: true, type: Array },
    loading: { required: true, type: Boolean },
    endDate: { required: true, type: String },
    startDate: { required: true, type: String },
    periodType: String,
    entityStatusId: [String, Number],
  }
}
</script>

<style scoped>

</style>